import { makeAutoObservable } from 'mobx';

class MessagesStore {
  // TODO: Add messages map, streaming state and helpers here when needed

  constructor() {
    // NOTE: Store left intentionally minimal for now.
    // When we start implementing logic, add observables/actions as needed.
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

export default MessagesStore;
